import React from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {UsersBody} from './components/UsersBody'
import {UsersHeader} from './components/UsersHeader'
import {UsuariosPageContextProvider} from './context/UsersPageContext'

interface Props {}

const breadCrumbs = [
  {
    title: 'Seguimiento',
    path: '/seguimiento/colaboradores',
    isSeparator: false,
    isActive: false,
  },
]

const UsersPageAdmin: React.FC<Props> = () => {
  return (
    <>
      <BasicBreadcrumbs breadcrumbs={breadCrumbs} fallbackTitle='Colaboradores' />
      <KTCard>
        <KTCardBody>
          <UsuariosPageContextProvider>
            <UsersHeader />
            <UsersBody />
          </UsuariosPageContextProvider>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export {UsersPageAdmin}
